import { H2 } from '@ahmdigital/ui';
import { isEmpty, map } from 'lodash/fp';
import React from 'react';

import { CrossSellContentType } from '../../../pages/insurance/types';
import { CtaType } from '../../../types/cta';
import { ImageType } from '../../../types/image';
import { ItemsWrapper, StyledPerkTile, TileWrapper } from './styles';
import uncapFpIterator from '../../../../utils/uncap-fp-iterator';
import WrappedSection from '../wrapped-section';

const mapWithIndex = uncapFpIterator(map);

type ItemProps = {
  cta: CtaType;
  description: string;
  image: ImageType;
  name: string;
};

const CrossSellSection = ({ content, insuranceType }: CrossSellContentType) => {
  if (isEmpty(content)) {
    return null;
  }

  return (
    <WrappedSection withBorder withWide>
      <H2 variant={['center', 'marginBottomSpacer8']}>Looking for more than {insuranceType} insurance?</H2>
      <ItemsWrapper>
        {mapWithIndex(
          (item: ItemProps, index: number) => (
            <TileWrapper key={index}>
              <StyledPerkTile {...item} />
            </TileWrapper>
          ),
          content,
        )}
      </ItemsWrapper>
    </WrappedSection>
  );
};

export default CrossSellSection;
